import React from "react";
import {Link} from "react-router-dom";
import {IFacility} from "../types";
import {translate} from "../../translate";
import {OptionalId} from "../../index";

type Props = {
    facility: OptionalId<IFacility>,
    excludeRoot?: boolean,
}

export default function FacilityPath({ facility, excludeRoot }: Props) {
    const path = [facility];
    while (path[0].parentFacility !== null) {
        path.unshift(path[0].parentFacility);
    }
    return <ul className='breadcrumb'>
        { !excludeRoot && <li className='breadcrumb-item'><Link to='..'>{translate('react/component/Satisfactory/General/worldOverview')}</Link></li> }
        {
            path.map(facility => <li className='breadcrumb-item' key={facility.id ?? -1}>
                { facility.id !== undefined ? <Link to={'../' + facility.id}>{facility.name}</Link> : facility.name }
            </li>)
        }
    </ul>
}
